import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-background py-16 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="font-display text-3xl font-bold tracking-tight">
              VYASTORE
            </Link>
            <p className="mt-4 text-background/70 max-w-md leading-relaxed">
              Découvrez des looks soigneusement sélectionnés pour sublimer votre style au quotidien.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/looks" className="text-background/70 hover:text-background transition-colors">
                  {t('nav.looks')}
                </Link>
              </li>
              <li>
                <Link to="/quiz" className="text-background/70 hover:text-background transition-colors">
                  {t('nav.quiz')}
                </Link>
              </li>
              <li>
                <Link to="/account" className="text-background/70 hover:text-background transition-colors">
                  {t('nav.account')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Aide</h3>
            <ul className="space-y-3">
              <li>
                <span className="text-background/70 hover:text-background transition-colors cursor-pointer">
                  {t('footer.faq')}
                </span>
              </li>
              <li>
                <span className="text-background/70 hover:text-background transition-colors cursor-pointer">
                  {t('footer.shipping')}
                </span>
              </li>
              <li>
                <span className="text-background/70 hover:text-background transition-colors cursor-pointer">
                  {t('footer.returns')}
                </span>
              </li>
              <li>
                <span className="text-background/70 hover:text-background transition-colors cursor-pointer">
                  {t('footer.contact')}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-background/20 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-background/60 text-sm">
            © {currentYear} VyaStore. Tous droits réservés.
          </p>
          <p>Par <a href="https://jokast38.fr">Jokast Kassa</a></p>
          <div className="flex gap-6 text-sm">
            <span className="text-background/60 hover:text-background transition-colors cursor-pointer">
              {t('footer.legal')}
            </span>
            <span className="text-background/60 hover:text-background transition-colors cursor-pointer">
              {t('footer.privacy')}
            </span>
            <span className="text-background/60 hover:text-background transition-colors cursor-pointer">
              {t('footer.terms')}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
